import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Member } from "../../models/interfaces/member.model";
import { Rating } from "../../models/interfaces/rating.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-rating",
  templateUrl: "rating.html",
})
export class RatingPage {

  private currentUser: Member;
  private rating$: any;
  private rating: Rating;
  private hl_id: any;
  private harelineid: string;
  private ratingForm: FormGroup;
  private stars = [];
  private isFormValid: boolean = false;
  private styleName: string ="";

  @Input() numStars: number = 5;
  @Input() readOnly: boolean = false;
  @Input() value: number = 0;
  @Output() clicked: EventEmitter<number> = new EventEmitter<number>();

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController,
    public navParams: NavParams, public alertCtrl: AlertController,
    private formBuilder: FormBuilder, private db: DbserviceProvider,
  ) {
    console.log("RatingPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.ratingForm = this.formBuilder.group({
      /*"hc_id": [""],
      "hc_name": [""],*/
      "hr_comment": [""],
      "stars": [""],
    });
  }

  private ionViewWillEnter() {
    console.log("RatingPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("RatingPage onInitPage");
    this.authService.currentUser.subscribe(
      (user) => {
        this.currentUser = user;
      });
    this.db.dbCol({
      "action": "select", "mapObject": "rating",
      "sqlExtended": " order by rating.rt_order"
    }).subscribe((data) => {
      this.rating = data;
      for (let i in data) {
        this.calc2(data[i].rt_name, 0);
      }
    });
  }

  private goback() {
    console.log("HarelineUpdatePage goback");
    this.navCtrl.pop();
  }

  private addRating(value: any) {
    console.log("RatingPage addRating, this.ratingForm.valid", this.ratingForm.valid);
    let ratings = {};
    let latings = [];
    let date = new Date().toISOString();
    const ratingValues: any = {
      "hl_id": this.navParams.data.hareline.hl_id,
      "hr_comment": value.hr_comment,
      "hr_date": date,
      "mb_id": this.currentUser.mb_id,
    };

    if ( this.isFormValid ) {
      this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM hareline_rating WHERE hareline_rating.mb_id=" + ratingValues.mb_id + " and hareline_rating.hl_id=" + ratingValues.hl_id })
        .subscribe((ret2) => {
          this.db.dbCol({ "action": "insert", "mapObject": "hareline_rating", ...ratingValues })
            .subscribe((ret3) => {
              Object.keys(this.stars).forEach((ratingName) => {
                let cnt = 0;
                this.stars[ratingName].forEach((element) => {
                  if (element === "star-half") {
                    cnt = cnt + .5;
                  }
                  else if (element === "star") {
                    cnt = cnt + 1;
                  }
                });
                ratings[ratingName] = cnt;
                for (let i = 0; i < (this.rating as any).length; i++) {
                  if (this.rating[i].rt_name === ratingName && cnt !== 0) {
                    if (this.navParams.data.isPutin){
                      cnt=5;
                    }
                    const ratingitemValues: any = {
                      "hi_value": cnt,
                      "hr_id": ret3.id,
                      "rt_id": this.rating[i].rt_id,
                    };
                    this.db.dbCol({ "action": "insert", "mapObject": "hareline_rating_item", ...ratingitemValues })
                      .subscribe();
                  }
                }
              });
              this.navCtrl.pop();
            });
        });
    }
  }

  private calc2(ratingName: string, index: number) {
    console.log("RatingPage calc2");
    if (this.stars[ratingName] === undefined) {
      this.stars[ratingName] = [];
      for (let i = 0; i < this.numStars; i++) {
        this.stars[ratingName].push("star-outline");
      }
    }
    else if (this.stars[ratingName] !== undefined) {
      if (this.stars[ratingName][index] === "star-half") // current one is half
      {
        this.stars[ratingName][index] = "star"; // set it to full
      }
      else if (this.stars[ratingName][index] === "star") // current one is Full
      {
        this.stars[ratingName][index] = "star-outline"; // set it to empty
      }
      else if (this.stars[ratingName][index] === "star-outline") // current one is empty
      {
        this.stars[ratingName][index] = "star-half"; // set it to half
      }
      else if (this.stars[ratingName][index] === undefined) {
        this.stars[ratingName][index] = "star-half";
      }
      for (let i = 0; i < index; i++) {
        this.stars[ratingName][i] = "star";
      }
      for (let i = index + 1; i < this.numStars; i++) {
        this.stars[ratingName][i] = "star-outline";
      }
    }
  }

  private starClicked(index: number, ratingName: string) {
    console.log("RatingPage starClicked");
    this.calc2(ratingName, index);
    this.isFormValid = true;
    this.clicked.emit(this.stars[ratingName]);
    for (let i in this.rating) {
      if (this.stars[this.rating[i].rt_name][0] === "star-outline") {
        this.isFormValid = false;
      }
     }
  }
}



// WEBPACK FOOTER //
// ./src/pages/rating/rating.ts